// globals: jQuery

import i4goIframeDialog from './I4goFrameDialog';

var I4goFrameDialogService;
var i4goFrameDialogServiceBillingInfo;
var i4goFrameDialogServiceRefund;

(function($) {

    var I4goFrameDialogRect = {
        width: '640',
        height: '480'
    };

    I4goFrameDialogService = function() {

    };

    I4goFrameDialogService.prototype.containerId = 'i4goFrameDialogFormContainer';

    I4goFrameDialogService.prototype.getContainer = function() {
        return $('#' + this.containerId);
    };
    I4goFrameDialogService.prototype.onEmvSuccess = function() {

    };
    I4goFrameDialogService.prototype.onSuccess = function() {

    };
    I4goFrameDialogService.prototype.init = function(callback, params) {
        this.isSuccess = false;
        $('<div id="' + this.containerId + '"></div>').appendTo('body');
        var $i4goFrameDialogFormContainer = this.getContainer();
        var context = this;
        var i4goIframeDialogOptions = params.i4goIframeDialogOptions ? params.i4goIframeDialogOptions : null;
        var options = {
            onDialogOpened: function() {
                i4goIframeDialog.onSuccess = function(form, data) {
                    context.onSuccess(form, data);
                    callback(form, data);
                    var $formDialog = $('#i4goFrameFormDialog');
                    var $dialog = $formDialog.closest('.ca-dialog');
                    $dialog.prev('.ui-widget-overlay').remove();
                    $dialog.remove();
                    $formDialog.remove();
                };
                i4goIframeDialog.onEmvSuccess = function(data) {
                    context.onEmvSuccess(data);
                    var $dialog = $('#i4goFrameFormDialog').closest('.ca-dialog');
                    $dialog.prev('.ui-widget-overlay').remove();
                    $dialog.remove();
                    $('#i4goFrameFormDialog').remove();
                };
                i4goIframeDialog.init(i4goIframeDialogOptions);
            }
        };
        if (params) {
            if (params.dialogOptions) {
                params.dialogOptions.width = I4goFrameDialogRect.width;
                params.dialogOptions.height = I4goFrameDialogRect.height;
            }
            options = $.extend(options, params);
        }
        $i4goFrameDialogFormContainer.caI4goFrameDialogForm(options);
    };

    I4goFrameDialogService.prototype.open = function(callback, params) {
        this.init(callback, params);
        this.getContainer().caI4goFrameDialogForm('openDialog');
    };

    i4goFrameDialogServiceRefund = new I4goFrameDialogService();
    i4goFrameDialogServiceRefund.onSuccess = function(form, data) {

        var associationKeys = {
            'cc_number' : 'cc_number',
            'cc_merchant_unique_id' : 'i4go_uniqueid',
            'cc_expirationyear' : 'i4go_expirationyear',
            'cc_expirationmonth' : 'i4go_expirationmonth'
        };

        jQuery.each(associationKeys, function(key, item) {
            if (!jQuery('.credit-card-form input[name="' + key + '"]').length) {
                jQuery('.credit-card-form').append('<input type="hidden" name="' + key + '" value="' + data[item] + '">');
            }
            jQuery('.credit-card-form input[name="' + key + '"]').attr('value', data[item]);
        });
    };

    $.widget('ca.caI4goFrameDialogForm', $.ca.caDialogForm, {
        options: {
            dialog: null,
            form: null,
            formParams: {},
            formUrl: '/i4go/get-frame-form',
            dialogOptions: {
                title: 'Payment Form',
                width: I4goFrameDialogRect.width,
                height: I4goFrameDialogRect.height,
                caProUI: true,
                staticForm: false,
            },
        },
    });

    i4goFrameDialogServiceBillingInfo = new I4goFrameDialogService();
    i4goFrameDialogServiceBillingInfo.onSuccess = function(form, data) {
        jQuery('#cc_date-month').val(data.i4go_expirationmonth);
        jQuery('#cc_date-year').val(data.i4go_expirationyear);
        var $container = jQuery('#paymentMethodEditForm');
        var address = data['i4go_streetaddress'] || '';
        $container.find('#bill_street_address').val(address);
        var zip = data['i4go_postalcode'] || '';
        $container.find('#bill_zip').val(zip);
    };
    i4goFrameDialogServiceBillingInfo.onEmvSuccess = function(data) {
        var request = data.request;
        var dataPrepared = {
            i4go_streetaddress: request.streetaddress,
            i4go_postalcode: request.zipcode,
            i4go_uniqueid: data.uniqueId,
            i4go_expirationmonth: request.i4go_expirationmonth,
            i4go_expirationyear: request.i4go_expirationyear,
            i4go_cardtype: request.cardtype
        };
        var $form = jQuery('#paymentMethodEditForm');
        i4goIframeDialog.setI4goParamsToForm($form, dataPrepared, function() {
            ;
        });
        i4goFrameDialogServiceBillingInfo.onSuccess(null, dataPrepared);
    };

    $.widget('ca.caI4goFrameDialogForm', $.ca.caDialogForm, {
        options: {
            dialog: null,
            form: null,
            formParams: {},
            formUrl: '/i4go/get-frame-form',
            dialogOptions: {
                title: '<b>Enter Credit/Debit Card to store on file</b>',
                width: I4goFrameDialogRect.width,
                height: I4goFrameDialogRect.height,
                caProUI: true,
                staticForm: false,
            },
        },
    });

})(jQuery);

export {
    I4goFrameDialogService,
    i4goFrameDialogServiceBillingInfo,
    i4goFrameDialogServiceRefund
}
